// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    scroll-behavior: smooth;
}

.App {
    overflow-x: hidden;
}

/* Smooth scroll for anchor links */
html {
    scroll-behavior: smooth;
}

body {
    font-family: 'Inter', sans-serif;
    letter-spacing: -0.01em;
}

/* Uniform headings */
h1, h2, h3, h4, h5, h6 {
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    letter-spacing: -0.02em;
}

/* Justified text */
.text-justify {
    text-align: justify;
    text-justify: inter-word;
}

/* Animation classes */
@keyframes fade-in {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes gradient-shift {
    0%, 100% {
        background-position: 0% 50%;
    }
    50% {
        background-position: 100% 50%;
    }
}

@keyframes float {
    0%, 100% {
        transform: translateY(0px);
    }
    50% {
        transform: translateY(-20px);
    }
}

@keyframes pulse-glow {
    0%, 100% {
        box-shadow: 0 0 20px rgba(139, 92, 246, 0.3);
    }
    50% {
        box-shadow: 0 0 40px rgba(139, 92, 246, 0.6);
    }
}

.animate-fade-in {
    animation: fade-in 0.6s ease-out forwards;
}

.animate-gradient {
    animation: gradient-shift 8s ease infinite;
    background-size: 200% 200%;
}

.animate-float {
    animation: float 3s ease-in-out infinite;
}

.animate-pulse-glow {
    animation: pulse-glow 2s ease-in-out infinite;
}

/* Hover effects */
button, a {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Custom scrollbar with gradient */
::-webkit-scrollbar {
    width: 12px;
}

::-webkit-scrollbar-track {
    background: linear-gradient(180deg, #f3f4f6 0%, #e5e7eb 100%);
}

::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #8b5cf6 0%, #ec4899 50%, #06b6d4 100%);
    border-radius: 6px;
    border: 2px solid #f3f4f6;
}

::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, #7c3aed 0%, #db2777 50%, #0891b2 100%);
}

/* Text gradient utilities */
.text-gradient {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

/* Glass morphism effect */
.glass-effect {
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
}

/* 3D card effect */
.card-3d {
    transform-style: preserve-3d;
    transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.card-3d:hover {
    transform: perspective(1000px) rotateY(5deg) rotateX(2deg);
}

/* Glowing border animation */
@keyframes border-glow {
    0%, 100% {
        border-color: rgba(139, 92, 246, 0.5);
    }
    50% {
        border-color: rgba(236, 72, 153, 0.8);
    }
}

.border-animate {
    animation: border-glow 3s ease-in-out infinite;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAIA;IACI,kBAAkB;AACtB;;AAEA,mCAAmC;AACnC;IACI,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,uBAAuB;AAC3B;;AAEA,qBAAqB;AACrB;IACI,gCAAgC;IAChC,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,mBAAmB;AACnB;IACI,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA,sBAAsB;AACtB;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,6BAA6B;IACjC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,4CAA4C;IAChD;IACA;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,0CAA0C;IAC1C,0BAA0B;AAC9B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,6CAA6C;AACjD;;AAEA,kBAAkB;AAClB;IACI,iDAAiD;AACrD;;AAEA,mCAAmC;AACnC;IACI,WAAW;AACf;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,0EAA0E;IAC1E,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,0EAA0E;AAC9E;;AAEA,4BAA4B;AAC5B;IACI,6DAA6D;IAC7D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA,0BAA0B;AAC1B;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,mCAAmC;IACnC,0CAA0C;AAC9C;;AAEA,mBAAmB;AACnB;IACI,4BAA4B;IAC5B,uDAAuD;AAC3D;;AAEA;IACI,0DAA0D;AAC9D;;AAEA,6BAA6B;AAC7B;IACI;QACI,qCAAqC;IACzC;IACA;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI,8CAA8C;AAClD","sourcesContent":["* {\n    scroll-behavior: smooth;\n}\n\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');\n\n.App {\n    overflow-x: hidden;\n}\n\n/* Smooth scroll for anchor links */\nhtml {\n    scroll-behavior: smooth;\n}\n\nbody {\n    font-family: 'Inter', sans-serif;\n    letter-spacing: -0.01em;\n}\n\n/* Uniform headings */\nh1, h2, h3, h4, h5, h6 {\n    font-family: 'Inter', sans-serif;\n    font-weight: 700;\n    letter-spacing: -0.02em;\n}\n\n/* Justified text */\n.text-justify {\n    text-align: justify;\n    text-justify: inter-word;\n}\n\n/* Animation classes */\n@keyframes fade-in {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes gradient-shift {\n    0%, 100% {\n        background-position: 0% 50%;\n    }\n    50% {\n        background-position: 100% 50%;\n    }\n}\n\n@keyframes float {\n    0%, 100% {\n        transform: translateY(0px);\n    }\n    50% {\n        transform: translateY(-20px);\n    }\n}\n\n@keyframes pulse-glow {\n    0%, 100% {\n        box-shadow: 0 0 20px rgba(139, 92, 246, 0.3);\n    }\n    50% {\n        box-shadow: 0 0 40px rgba(139, 92, 246, 0.6);\n    }\n}\n\n.animate-fade-in {\n    animation: fade-in 0.6s ease-out forwards;\n}\n\n.animate-gradient {\n    animation: gradient-shift 8s ease infinite;\n    background-size: 200% 200%;\n}\n\n.animate-float {\n    animation: float 3s ease-in-out infinite;\n}\n\n.animate-pulse-glow {\n    animation: pulse-glow 2s ease-in-out infinite;\n}\n\n/* Hover effects */\nbutton, a {\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Custom scrollbar with gradient */\n::-webkit-scrollbar {\n    width: 12px;\n}\n\n::-webkit-scrollbar-track {\n    background: linear-gradient(180deg, #f3f4f6 0%, #e5e7eb 100%);\n}\n\n::-webkit-scrollbar-thumb {\n    background: linear-gradient(180deg, #8b5cf6 0%, #ec4899 50%, #06b6d4 100%);\n    border-radius: 6px;\n    border: 2px solid #f3f4f6;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: linear-gradient(180deg, #7c3aed 0%, #db2777 50%, #0891b2 100%);\n}\n\n/* Text gradient utilities */\n.text-gradient {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n/* Glass morphism effect */\n.glass-effect {\n    background: rgba(255, 255, 255, 0.1);\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n/* 3D card effect */\n.card-3d {\n    transform-style: preserve-3d;\n    transition: transform 0.6s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.card-3d:hover {\n    transform: perspective(1000px) rotateY(5deg) rotateX(2deg);\n}\n\n/* Glowing border animation */\n@keyframes border-glow {\n    0%, 100% {\n        border-color: rgba(139, 92, 246, 0.5);\n    }\n    50% {\n        border-color: rgba(236, 72, 153, 0.8);\n    }\n}\n\n.border-animate {\n    animation: border-glow 3s ease-in-out infinite;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
